import React from "react";

import { multipleClassNames } from "shared/utilities";
import styles from "./Title.module.scss";

export const Title = ({ children, className = [] }) => {
  const style = [styles.input, ...className];
  return <h1 className={multipleClassNames(style)}>{children}</h1>;
};
